import React from 'react';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import About from './pages/About';
import Products from './pages/Products';
import Technology from './pages/Technology';
import Footer from './components/Footer';
import './styles/GlobalStyle.css';
import PigFarmService from './pages/pig-farm';
import WaspSystem from './pages/wasp-system';
import AASSystem from './pages/aas';
import AIPage from './pages/ai';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <div className='App'>
        <ScrollToTop />
        <Navbar />
        <Switch>
          <Route exact path='/' component={Products} />
          <Route path='/about' component={About} />
          <Route path='/technology' component={Technology} />
          <Route exact path='/products' component={Products} />
          <Route path='/products/pig-farm' component={PigFarmService} />
          <Route path='/products/wasp-system' component={WaspSystem} />
          <Route path='/products/aas' component={AASSystem} />
          <Route path='/products/ai' component={AIPage} />
        </Switch>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
